import { IReducerState } from 'store/main-reducer';
import { AccountantTuple } from 'types';

export const getAccountantLookupIsLoading = (state: IReducerState): boolean => state.accountantLookupReducer.isLoading;
export const getAccountantLookupError = (state: IReducerState): string | undefined => state.accountantLookupReducer.error;
export const getAccountantLookupResults = (state: IReducerState): AccountantTuple[] => state.accountantLookupReducer.accountantResults;
